/**
 * A code column in a customer's list is the CUSTOMER's code, until the Item master says
 * otherwise. `Enquiry Item.item_code` is a Frappe Link, and one unknown value fails the whole
 * wholesale write — "Could not find Row #1: Item Code: 312381, Row #2: …" on an uploaded
 * screenshot, 2026-09-17. The mail path has checked codes against the master since August
 * (`verifyItemCodes` in `useMailExtraction.ts`); this is the same rule for any caller.
 *
 * An unknown code is not thrown away: it stays on the line's wording, where the purchaser can
 * see what the customer wrote and the matcher can use it.
 */
export function dropUnknownCodes<T extends { description: string; item_code: string | null }>(
  items: readonly T[],
  known: ReadonlySet<string>,
): { items: T[]; rejected: string[] } {
  const rejected: string[] = []
  const out = items.map((item) => {
    if (!item.item_code || known.has(item.item_code)) return item
    rejected.push(item.item_code)
    return { ...item, item_code: null, description: `${item.description} (code ${item.item_code} not in catalogue)` }
  })
  return { items: out, rejected: [...new Set(rejected)] }
}
